import actionTypes from '../constants/action-types';

const addCustomColorPalette = (palette) => ({
  type: actionTypes.ADD_CUSTOM_COLOR_PALETTE,
  payload: {
    palette,
  },
});

export default addCustomColorPalette;
